const bulkOrderingsTableColumns = [
  { key: 'name', label: 'Name', className: '', allowsSorting: false },
  { key: 'stage', label: 'Stage', className: '', allowsSorting: false },
  {
    key: 'quantity',
    label: 'Quantity',
    className: '',
    allowsSorting: false
  },
  {
    key: 'supplier',
    label: 'Supplier',
    className: '',
    allowsSorting: false
  },
  {
    key: 'requested_at',
    label: 'Requested',
    className: '',
    allowsSorting: true
  },
  {
    key: 'tracking_link',
    label: 'Shipments',
    allowsSorting: true
  },
  {
    key: 'completion',
    label: 'Completion',
    className: '',
    allowsSorting: false
  }
];

export default bulkOrderingsTableColumns;
